/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Abmelden`
};

const en_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logout`
};

const es_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar sesión`
};

const fr_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Se déconnecter`
};

const it_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Logout`
};

const nl_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Afmelden`
};

const pt_profile__logout = /** @type {(inputs: {}) => string} */ () => {
	return `Terminar sessão`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__logout(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__logout", locale)
	if (locale === "de") return de_profile__logout(inputs)
	if (locale === "en") return en_profile__logout(inputs)
	if (locale === "es") return es_profile__logout(inputs)
	if (locale === "fr") return fr_profile__logout(inputs)
	if (locale === "it") return it_profile__logout(inputs)
	if (locale === "nl") return nl_profile__logout(inputs)
	return pt_profile__logout(inputs)
};